import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/routecode/";

export default class RouteCodeApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getRouteCodes(params) {
    return await request.post(`${rootRoute}getRouteCodes`, {
      filter: params,
      parameters: {},
    });
  }
  async getRouteCode(id) {
    return await request.post(`${rootRoute}getRouteCodes`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createRouteCode(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createRouteCode`, { data });
  }
  async deleteRouteCode(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteRouteCode`, { data });
  }
  async editRouteCode(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateRouteCode`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importRouteCode`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getRouteCodeimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportRouteCode`, {
      filter: filter,
      format: format
    });
  }
}
